import { Element } from 'rustig';
import $ from 'jquery';

export class ClearInputs {
  public static Wireup() {
    $(document).on('click', '[data-clear]', function () {
      let $button = $(this);
      let key = $button.data('clear');

      $('[data-clear-target*=\'' + key + '\']').each(function (i, e) {
        new Element($(e)).value(null);
      });
      $button.addClass('display-none');
    });

    let onChange = function ($target: JQuery) {
      let keys = (<string>$target.data('clear-target')).split(',');

      if (new Element($target).value())
        keys.forEach(x => $('clear'.asDataSelector(x)).removeClass('display-none'));
      else {
        keys.forEach(function (x) {
          let $element = $('clear'.asDataSelector(x));
          let someInputStillHasValue = false;

          $('[data-clear-target*="' + $element.data('clear') + '"]').each(function (i, e) {
            if (new Element($(e)).value())
              someInputStillHasValue = true;
          });

          if (!someInputStillHasValue)
            $element.addClass('display-none')
        });
      }
    }

    $(document).on('change', '[data-clear-target]', function () {
      let $target = $(this);
      onChange($target);
    });

    $(document).on('clear-inputs-refresh', function () {
      let $elements = $('[data-clear-target]');
      $elements.each(function () {
        onChange($(this));
      });
    });

  }
}
